import {
  CountryOfResidence,
  TFunction,
  useTranslation,
} from "@outschool/localization";
import React from "react";

import exhaustiveCheck from "../../exhaustiveCheck";

function translateCountryOfResidence({
  countryOfResidenceCode,
  t,
  addPrefix,
}: {
  countryOfResidenceCode: CountryOfResidence["code"];
  t: TFunction;
  addPrefix?: boolean;
}): string {
  switch (countryOfResidenceCode) {
    case "us":
      return addPrefix ? t("the United States") : t("United States");
    case "gb":
      return addPrefix ? t("the United Kingdom") : t("United Kingdom");
    case "ca":
      return t("Canada");
    case "au":
      return t("Australia");
    case "nz":
      return t("New Zealand");
    case "in":
      return t("India");
    case "es":
      return t("Spain");
    case "kr":
      return t("South Korea");
    case "mx":
      return t("Mexico");
    default:
      throw exhaustiveCheck(countryOfResidenceCode);
  }
}

export function useTranslateCountryOfResidence(
  {
    addPrefix,
  }: {
    addPrefix?: boolean;
  } = { addPrefix: true },
) {
  const { t } = useTranslation("shared\\CountryOfResidence");

  return React.useCallback(
    (countryOfResidenceCode: CountryOfResidence["code"]) =>
      translateCountryOfResidence({ countryOfResidenceCode, t, addPrefix }),
    [t, addPrefix],
  );
}
